module.exports = __webpack_public_path__ + "img/005.bdf2b354.jpg";